import * as React from 'react';
import { Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import { VideoIcon } from '@fiverr-private/visuals';
import { BookConsultationButtonProps, Theme } from './types';

const BookConsultationButton = ({
  isPro = false,
  className,
  withIcon = false,
  theme = Theme.grey,
}: BookConsultationButtonProps) => {
  const buttonIntent = getButtonIntent(isPro, theme);

  return (
    <Button
      variant="outline"
      size={isPro && withIcon ? 'md' : 'sm'}
      intent={buttonIntent}
      className={className}
      id="consultation-button"
    >
      {withIcon && <VideoIcon />}
      <I18n k="consultation.book_consultation" />
    </Button>
  );
};

const getButtonIntent = (isPro: boolean, theme: Theme) => {
  if (isPro) {
    return 'primary';
  }

  switch (theme) {
    case Theme.grey:
      return 'primary';
    case Theme.lightGrey:
      return 'secondary';
    default:
      return 'primary';
  }
};

export { Theme };

export default BookConsultationButton;
